var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02166 20.7302C2.48694 16.0092 2.7325 10.8173 5.95645 7.27352C9.27606 3.62454 15.5207 1.97944 23.2414 4.14125C23.5357 4.22365 23.7657 4.45364 23.8481 4.74793C26.0098 12.4688 24.3647 18.7133 20.7157 22.0329C17.172 25.2568 11.9801 25.5023 7.2591 21.9676L4.99205 24.2347C4.65035 24.5764 4.09633 24.5764 3.75461 24.2347C3.41291 23.893 3.41291 23.3389 3.75461 22.9972L6.02166 20.7302ZM14.7186 9.26579C15.0721 8.82385 15.7724 9.07954 15.7724 9.65054V12.2016H17.4891C17.9903 12.2016 18.2663 12.7972 17.9488 13.194L14.45 17.5677C14.0965 18.0096 13.3962 17.754 13.3962 17.1829V14.6319H11.6795C11.1783 14.6319 10.9023 14.0363 11.2197 13.6396L14.7186 9.26579Z",
    fill: "#1E6714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendation);
export default __webpack_public_path__ + "static/media/recommendation.c46142b583d52bcd30484511af7ba383.svg";
export { ForwardRef as ReactComponent };